import { reactToCwp } from '../../common/react-utils.jsx'
import { Navigation } from './src/Navigation.tsx'

export default reactToCwp(Navigation)
